<template>
    <div ref="modal" class="modal fade edit_form_and_checklist-popup" tabindex="-1" role="dialog" :id="id">
        <div class="modal-dialog" role="document">
            <validation-observer ref="edit_form_obs">
                <form @submit.prevent="submit" ref="form">
                    <div class="modal-content">
                        <div class="modal-header new-design">
                            <h5 class="modal-title"> {{customerPortal?'':'Edit'}} {{ fieldName }}</h5>
                            <div class="close-icon clickable" data-dismiss="modal" aria-label="Close">
                                <svg class="close-icon clickable" data-dismiss="modal" aria-label="Close" width="24" height="24"
                                     viewBox="0 0 24 24" fill="#fff"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z" fill="#CBCFD3"/>

                                </svg>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="custom-field" v-if="form?.questions">
                                <div class="col-md-12 col-xs-12" v-for="(question,index) of form.questions" :key="index">
                                    <input type="hidden" name="csrf_token" :value="csrfToken" >
                                    <form-longtext v-if="isLongText(question)" v-model="form.questions[index]"  :is-pop-up="true"></form-longtext>
                                    <form-button-group v-else-if="isGroupButton(question)"
                                                       v-model="form.questions[index]"  :is-pop-up="true"></form-button-group>
                                    <form-toggle v-else-if="isCheckbox(question)" v-model="form.questions[index]"  :is-pop-up="true"></form-toggle>
                                    <form-text v-else-if="isTextBox(question)" v-model="form.questions[index]"  :is-pop-up="true"></form-text>
                                    <form-time v-else-if="isTime(question)" v-model="form.questions[index]"
                                               :time-format="timeFormat"  :is-pop-up="true"></form-time>
                                    <form-radio-button v-else-if="isEnum(question)"
                                                       v-model="form.questions[index]" :is-pop-up="true"></form-radio-button>
                                    <form-checkbox v-else-if="isSet(question)" v-model="form.questions[index]"  :is-pop-up="true"></form-checkbox>
                                    <form-date v-else-if="isDate(question)" :date-format="dateFormat"
                                               v-model="form.questions[index]" :is-pop-up="true"></form-date>
                                    <form-plus-minus v-else-if="isPlusMinus(question)"
                                                     v-model="form.questions[index]"  :is-pop-up="true"></form-plus-minus>
                                    <form-drop-down v-else-if="isDropdown(question)"
                                                    v-model="form.questions[index]"  :is-pop-up="true"></form-drop-down>
                                    <form-List v-else-if="isList(question)" v-model="form.questions[index]"  :is-pop-up="true"></form-List>
                                    <form-signature v-else-if="isSignature(question)" v-model="form.questions[index]"
                                                    :s3-path="s3Path"  :is-pop-up="true"></form-signature>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer new-design width-mobile-100">
                            <div class="col-md-12 width-mobile-100" :class="{'actions-inquiry' : isInquiry}">
                                <button type="submit" class="btn btn-primary new-design"  :disabled="loading"
                                        :class="{disabled:loading , ' submit-btn-inquiry ' : isInquiry}">
                                    <span v-if="!loading" style="color: #ffffff">Save</span>
                                    <span v-else><i class="fa fa-spinner fa-spin"></i> Loading...</span>
                                </button>

                                <button  type="button" data-dismiss="modal" aria-label="Close"
                                         :class="{'cancel-btn-inquiry' : isInquiry}"
                                         class="btn btn-default new-design">cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import {editFormAndChecklistForInquiry,editFormAndChecklist} from "@/modules/Forms/api"
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, email} from 'vee-validate/dist/rules';
import moment from 'moment'
import {atLeastOneOptionSelected, verifyPhoneNumbers} from '@/modules/Fields/validations'
import {EventBus} from "@/events/event-bus";


email.message = 'This is invalid email'
required.message = 'This field is required'

extend('email', email);
extend('required', required);
// extend('atLeastOneOptionSelected', atLeastOneOptionSelected)


export default {
    name: "FormAndChecklistEditPopup",
    props: {
        id: {
            required: true
        },
        value: {
            type: Object
        },
        dateFormat: {
            type: String
        },
        timeFormat: {
            type: String
        },
        fieldName: '',
        declineForm: {
            type: Object,
            default() {
                return {}
            }
        },
        acceptForm: {
            type: Object,
            default() {
                return {}
            }
        },
        s3Path: {
            type: String,
            default() {
                return '';
            }
        },
        isInquiry: {
            type: Number,
            default() {
                return 0;
            }
        },
        itemId: null,
        customerPortal: null,
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            constants: {
                ENUM: 'Enum',
                LONGTEXT: 'long_text',
                CHECKBOX: 'checkbox',
                TEXT_BOX: 'text_input',
                TIME: 'time',
                SET: 'set',
                DATE_INPUT: 'date',
                TEXT: 'text',
                DROPDOWN: 'dropdown',
                LIST: 'multiselect',
                SIGNATURE: 'signature'
            },
            form: this.value,
            loading: false,
            formLoading: false,
            csrfToken: window.csrf_token || ''
        }
    },
    computed: {},
    methods: {
        listenOnPopupToggle() {
            if (this.customerPortal){
            $(this.$refs['modal']).on('shown.bs.modal', (e) => {
                // $('#view_booking_portal').detach();

            })
            $(this.$refs['modal']).on('hidden.bs.modal', (e) => {
                // var link = $('<link>', {
                //     rel: 'stylesheet',
                //     type: 'text/css',
                //     href: '/css/booking/view_booking_portal.css?v=2.1'
                // });
                // $('head').append(link);
            })
            }
        },

        isGroupButton(question) {
            return question.attribute_type === this.constants['ENUM'] && question.is_new === 1
        },
        isLongText(question) {
            return question.attribute_type === this.constants['LONGTEXT']
        },
        isCheckbox(question) {
            return question.attribute_type === this.constants['CHECKBOX']
        },
        isTextBox(question) {
            return question.attribute_type === this.constants['TEXT_BOX'] && question.is_new === 0;
        },
        isTime(question) {
            return question.attribute_type === this.constants['TIME']
        },
        isEnum(question) {
            return question.attribute_type === this.constants['ENUM'] && question.is_new === 0;
        },
        isSet(question) {
            return question.attribute_type === this.constants['SET']
        },
        isDropdown(question) {
            return question.attribute_type === this.constants['DROPDOWN'] && question.is_new === 0;
        },
        isList(question) {
            return question.attribute_type === this.constants['LIST'];
        },
        isDate(question) {
            return question.attribute_type === this.constants['DATE_INPUT'];
        },
        isPlusMinus(question) {
            return question.attribute_type === this.constants['TEXT_BOX']  && question.is_new === 1;
        },
        isSignature(question) {
            return question.attribute_type === this.constants['SIGNATURE'];
        },
        async submit() {
            const form = this.$refs.form;
          if (! await this.$refs.edit_form_obs.validate()) {
            let  allInvalidInputs = Array.from(this.$el.querySelectorAll('span.error-label'))
                .filter(span => span.textContent.trim().length > 0);
            let firstInvalidElement = allInvalidInputs? allInvalidInputs[0] : null;
            // Now, errorSpans contains all span elements with 'error-label' class that have text
            if (firstInvalidElement) {// Check for any parent with specific ID
                firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
              }
            return false;
          }
          this.loading = true

          if (form instanceof HTMLFormElement) {
                const formData = new FormData(form);
                // Now you can work with formData, for example, send it via AJAX
                if(this.isInquiry){

                    editFormAndChecklistForInquiry(this.itemId, formData).then((response) => {
                        $.notify(response.data.message, response.data.type);
                        // EventBus.$emit('onUpdateFormAndCheckList', null);
                        $(this.$refs['modal']).modal('toggle')
                        this.loading = false
                    }).catch((error) => {
                        // Handle any errors here
                    });
                }else{
                  if (this.customerPortal){
                    // Close this edit popup first, then call decline/accept (which manage their own notifications + backdrop)
                    $(this.$refs['modal']).modal('hide');
                    editFormAndChecklist(this.itemId, formData).then((response) => {
                      EventBus.$emit('onUpdateFormAndCheckList', null);
                      this.loading = false;
                      if (this.declineForm && !(Object.keys(this.declineForm).length === 0 && this.declineForm.constructor === Object)){
                        window.declineQuote(`/customerPortal/${this.declineForm.company_name}/${this.declineForm.company_id}/quote/decline/${this.declineForm.booking_id}?from_decline_form=1`);
                      } else if (this.acceptForm && !(Object.keys(this.acceptForm).length === 0 && this.acceptForm.constructor === Object)){
                        window.acceptQuote(`/customerPortal/${this.acceptForm.company_name}/${this.acceptForm.company_id}/quote/accept/${this.acceptForm.booking_id}`);
                      }
                    }).catch((error) => {
                      this.loading = false;
                      // Handle any errors here
                    });
                  }else{
                    editFormAndChecklist(this.itemId, formData).then((response) => {
                        $.notify(response.data.message, response.data.type);
                        EventBus.$emit('onUpdateFormAndCheckList', null);
                        $(this.$refs['modal']).modal('toggle')
                        this.loading = false
                    }).catch((error) => {
                        // Handle any errors here
                    });
                }
                }
            } else {
                console.error('Invalid form reference');
            }

        },
    },
    filters: {},
    mounted() {
        if (this.customerPortal){
            if (this.declineForm && !(Object.keys(this.declineForm).length === 0 && this.declineForm.constructor === Object)){
                this.form = this.declineForm;
            }
            if (this.acceptForm && !(Object.keys(this.acceptForm).length === 0 && this.acceptForm.constructor === Object)){
                this.form = this.acceptForm;
            }
          this.$nextTick(function () {
            window.accptDeclineFormsMounted = true;
          });
        }
        this.listenOnPopupToggle()
    },
    watch: {
        form: {
            handler(form) {
                this.$emit('input', form)
            },
            deep: true
        }
    }
}
</script>

<style scoped>

.modal-content {
    background-clip: padding-box;
    background-color: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    outline: 0 none;
    position: relative;
}

.modal-header.new-design {
    border-bottom: unset;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.modal-footer.new-design {
    border-top: unset;
}

.close-icon {
    float: right;
}

.clickable {
    cursor: pointer;
}

.error-label {
    top: 8px;
    position: relative;
}

.submit-btn-inquiry{
    margin-right: 30px !important;
    margin-bottom: 10px !important;
}

.cancel-btn-inquiry{
    margin-left: 28px !important;
    margin-bottom: 10px !important;
}
@media (max-width: 767px){
    .submit-btn-inquiry{
        margin: 10px auto !important;
    }

    .cancel-btn-inquiry{
        margin: 10px auto !important;
    }
    .actions-inquiry{
        text-align: center;
    }
}


    .btn.new-design {
    border-radius: 8px;
    padding: 12px 16px;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
}

.btn-primary.new-design {
    background: #2E4051 !important;
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-loading {

}

label {
    display: block;
    position: absolute;
    top: 30%;
    transform: translateY(-50%);
    left: 32px;
    color: #2E4051;
    transform-origin: left top;
    user-select: none;
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1), color 150ms cubic-bezier(0.4, 0, 0.2, 1), top 500ms;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
}

.form-control.new-design {
    padding-top: 30px !important;
}

input:focus + label,
input.is-valid + label {
    transform: translateY(-100%) scale(0.75);
}

.date-icon, .phone-icon, .email-icon, .address-icon {
    background-position-y: 25px !important;
}

.modal-header.new-design {
    border-bottom: unset;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.modal-footer.new-design {
    border-top: unset;
    text-align: left;
    padding-top: 0px;
}

.modal-footer {
    padding: 15px 17px 15px 15px;
}
.custom-field .p-0-1{
    padding: 0px 1px !important;
}
.close-icon {
    float: right;
}

.clickable {
    cursor: pointer;
}

.error-label {
    top: 8px;
    position: relative;
}

.btn.new-design {
    border-radius: 8px;
    padding: 12px 16px;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
}

.btn-primary.new-design {
    background: #2E4051 !important;
    float: right;
}
.btn-default.new-design{
    color: #2E4051
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}
.col-md-12{
    padding: 0px !important;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.btn.new-design {
    margin-bottom: unset;
    margin: 0px 0px 10px 0px;
}

@media (max-width: 768px) {
    .m-b--20 {
        margin-bottom: -20px;
    }
    .modal-footer.new-design {
        height: auto;
        display: inline-flex !important;
    }
    .width-mobile-100{
        width: 100% !important;
    }

    .modal-header.new-design .modal-title {
        font-family: 'Roboto', serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #2E4051;
        display: inline;
    }



    .btn.new-design {
        width: 100%
    }
    .btn-default.new-design{
        margin-bottom: 10px;
    }
}

</style>